<template>
	<div class="photo">
		<div @click="close" class="close">×</div>
		<div v-if="showControl" @click="toPrev" class="prev"> < </div>
		<div v-if="showControl" @click="toNext" class="next"> > </div>
		<div class="box">
			<a-carousel ref="carousel" :dots="false">
				<div class="imgbox" v-for="(item,index) in list" :key="index"><img style="margin-left: auto;margin-right: auto;" :src="item" alt=""></div>
			</a-carousel>
		</div>
	</div>
</template>

<script>
	export default {
		
		props: ["list","showControl"],
		data() {
			return {
				
			}
		},
		mounted() {

		},
		methods: {
			toPrev(){
				this.$refs.carousel.prev();
			},
			toNext(){
				this.$refs.carousel.next();
			},
			close() {
				this.$emit("close");
			}
		}
	}
</script>

<style scoped>
	.prev{
		font-size: 45px;
		color: white;
		position: absolute;
		top: 50vh;
		left:30px;
	}
	
	.next{
		font-size: 45px;
		color: white;
		position: absolute;
		top: 50vh;
		right: 30px;
	}
	
	.photo {
		width: 100%;
		height: 100vh;
		background-color: rgba(0, 0, 0, 0.8);
		position: fixed;
		top: 0;
		z-index: 9999;
	}

	.box {
		margin-top: 200px;
		width: 1200px;
		height: 400px;
		margin-left: auto;
		margin-right: auto;
	}
	
	.box img{
		/* width: 100%; */
		/* height: 400px; */
		text-align: center;
		object-fit: cover;
	}
	
	.imgbox{
		width: 100%;
		display: flex;
		justify-content: center;
		align-self: center;
	}
	
	
	.imgbox img{
		width: 1000px;
	}

	.close {
		color: white;
		font-size: 40px;
		position: absolute;
		top: 30px;
		right: 30px;
		cursor: pointer;
	}

	.ant-carousel :deep(.slick-slide) {
		text-align: center;
		height: 160px;
		line-height: 160px;
		background: #364d79;
		overflow: hidden;
	}

	.ant-carousel :deep(.slick-arrow.custom-slick-arrow) {
		width: 25px;
		height: 25px;
		font-size: 25px;
		color: #fff;
		background-color: rgba(31, 45, 61, 0.11);
		opacity: 0.3;
		z-index: 1;
	}

	.ant-carousel :deep(.custom-slick-arrow:before) {
		display: none;
	}

	.ant-carousel :deep(.custom-slick-arrow:hover) {
		opacity: 0.5;
	}

	.ant-carousel :deep(.slick-slide h3) {
		color: #fff;
	}
</style>



// WEBPACK FOOTER //
// src/components/photo/PhotoViewStudent.vue